import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const CTASection = () => (
  <section className="relative overflow-hidden bg-[#f6f3ed] py-20 sm:py-28">
    <div className="absolute inset-x-0 top-0 mx-auto h-px max-w-7xl bg-gray-900/10" aria-hidden="true" />
    <motion.div
      initial={false}
      transition={{ duration: 0.5 }}
      className="mx-auto max-w-4xl px-4 text-center sm:px-6"
    >
      <p className="text-xs font-bold uppercase tracking-[0.24em] text-neon-orange">Prochaine étape</p>
      <h2 className="mt-5 text-4xl font-bold tracking-[-0.04em] text-gray-950 sm:text-6xl">
        Clarifions le système qui fera avancer votre entreprise.
      </h2>
      <p className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-gray-600">
        Présentez votre contexte, vos priorités et ce qui bloque aujourd’hui. Nous cadrerons une
        prochaine action réaliste avant de parler outils ou fonctionnalités.
      </p>
      <Link
        to="/reserver"
        className="mt-9 inline-flex min-h-14 w-full items-center justify-center rounded-full bg-gray-950 px-8 py-4 font-bold text-white shadow-xl shadow-gray-950/15 transition hover:-translate-y-0.5 hover:bg-neon-orange focus:outline-none focus:ring-4 focus:ring-neon-orange/25 sm:w-auto"
      >
        Demander mon diagnostic
        <span className="ml-3" aria-hidden="true">↗</span>
      </Link>
    </motion.div>
  </section>
);

export default CTASection;
